import { render, staticRenderFns } from "./MassRatioCalculation.vue?vue&type=template&id=bb7d2274&scoped=true"
import script from "./MassRatioCalculation.vue?vue&type=script&lang=js"
export * from "./MassRatioCalculation.vue?vue&type=script&lang=js"
import style0 from "./MassRatioCalculation.vue?vue&type=style&index=0&id=bb7d2274&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7d2274",
  null
  
)

export default component.exports